export default function buildTradePendingUrls(parameters: {
    vehicle_id: string;
    zip_code: string;
    partner_id: string;
    url: string;
    mileage?: number; // TradePending doesn't require mileage
}): [string, string] {
    const queryString = new URLSearchParams();

    Object.entries(parameters)
        .filter(([key, val]) => val !== undefined)
        .forEach(([key, val]) => queryString.append(key, `${val}`));

    return [
        `https://snap-api.tradepending.com/api/v4/report?${queryString}`,
        `https://snap-api.tradepending.com/api/v4/report-html?${queryString}`,
    ];
}
